<template>
  <Row>
    <Col span="18">
      <Input v-model="searchName" placeholder="请输入名称" class="public-inp" />
      <Input
        v-model="cellPhone"
        placeholder="请输入手机号"
        class="public-inp"
      />
      <Select v-model="status" placeholder="请选择状态" class="public-inp">
        <Option value="">全部</Option>
        <Option v-for="e in statusList" :value="e.value" :key="e.value">{{
          e.name
        }}</Option>
      </Select>
      <Button type="primary" icon="md-search" @click="getList()" v-access="'userManagement.query'" >搜索</Button>
      <Button @click="resetList()"  v-access="'userManagement.reset'">重置</Button>
    </Col>
    <Col span="6">
      <Button type="primary" icon="md-add" class="public-fr" @click="openFn()" v-access="'userManagement.add'"
        >添加用户</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
          
            :value="row.status == 1"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a href="javascript:;" @click="auth(row, index)" v-access="'userManagement.details'">数据权限</a>
          <a href="javascript:;" @click="openFn(row, index)" v-access="'userManagement.edit'">编辑</a>
          <a href="javascript:;" @click="removeFn(row)" v-access="'userManagement.delte'">删除</a>
          <a href="javascript:;" @click="passwordFn(row)" v-access="'userManagement.edit'">修改密码</a>
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增用户' : '编辑用户'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="名称" prop="name">
          <Input v-model="formItem.name" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="手机号" prop="cellPhone">
          <Input
            v-model="formItem.cellPhone"
            placeholder="请输入手机号"
          ></Input>
        </FormItem>
        <FormItem label="账号" prop="loginId">
          <Input v-model="formItem.loginId" placeholder="请输入账号"></Input>
        </FormItem>
        <FormItem label="密码" prop="pwd" v-if="formTitle == 0">
          <Input v-model="formItem.pwd" placeholder="请输入密码"></Input>
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input v-model="formItem.email" placeholder="请输入邮箱"></Input>
        </FormItem>
        <FormItem label="联系电话" prop="tel">
          <Input v-model="formItem.tel" placeholder="请输入联系电话"></Input>
        </FormItem>
        <FormItem label="角色" prop="roleType">
          <Select v-model="formItem.roleType" placeholder="请选择角色">
            <Option v-for="e in roleList" :value="e.code" :key="e.code">{{
              e.roleName
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="所属部门" prop="department">
          <span ref="brick"></span>
          <Treeselect
            v-model="formItem.department"
            :data="selectData"
            text-field-name="depName"
            value-field-name="code"
            size="small"
            placeholder="全部部门"
          ></Treeselect>
        </FormItem>
        <FormItem label="状态" prop="status">
          <Select v-model="formItem.status" placeholder="请选择状态">
            <Option v-for="e in statusList" :value="e.value" :key="e.value">{{
              e.name
            }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改密码 -->
    <Modal
      v-model="formModel2"
      title="修改密码"
      :loading="formModalLoading2"
      :mask-closable="false"
      @on-ok="passwordSubmit"
      @on-cancel="passwordCancel"
    >
      <Form
        ref="formValidate2"
        :model="formItem2"
        :rules="ruleValidate2"
        :label-width="80"
      >
        <FormItem label="名称">
          <span>{{ formItem2.name }}</span>
        </FormItem>
        <FormItem label="账号">
          <span>{{ formItem2.loginId }}</span>
        </FormItem>
        <FormItem label="密码" prop="pwd">
          <Input v-model="formItem2.pwd" placeholder="请输入密码"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 用户权限 -->
    <Modal
      v-model="authModalVisible"
      title="用户权限"
      :loading="authModalLoading"
      :mask-closable="false"
      width="80%"
      @on-ok="permissionTreeSubmmit"
      @on-cancel="permissionTreeCancel"
    >
      <Form :model="formItem2" :rules="ruleValidate2" :label-width="80">
        <FormItem label="全选：">
          <Checkbox v-model="isAllSelect" @on-change="checkChange"></Checkbox>
        </FormItem>
        <FormItem label="门店：">
          <Select :disabled="isAllSelect" v-model="shopInfoValue" multiple>
            <Option
              v-for="item in shopInfoQueryList.data || []"
              :key="item.retCode"
              :value="item.retCode"
              >{{ item.retName || item.retCode }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="资金商：">
          <Select :disabled="isAllSelect" v-model="spInfoValue" multiple>
            <Option
              v-for="item in spInfoQueryAll || []"
              :key="item.code"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="平台：">
          <Select :disabled="isAllSelect" v-model="sysPlatformValue" multiple>
            <Option
              v-for="item in sysPlatformAll || []"
              :key="item.code"
              :value="item.code"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <div></div>
      </Form>
    </Modal>
  </Row>
</template>
<script>
import Treeselect from "vue-treeselect";
const columns = [
  {
    title: "名称",
    key: "name",
  },
  {
    title: "手机号",
    key: "cellPhone",
  },
  {
    title: "所属部门",
    key: "departmentName",
  },
  {
    title: "角色",
    key: "roleName",
  },
  {
    title: "电话",
    key: "tel",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
const statusList = [
  { name: "正常", value: "1" },
  { name: "锁住", value: "2" },
  { name: "停用", value: "3" },
  { name: "删除", value: "5" },
];

import { mapGetters } from "vuex";
export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      statusList,
      loading: false,
      columns,
      tbList: [],
      searchName: "",
      cellPhone: "",
      status: "",
      page: 1,
      pageSize: 10,
      total: 0,
      formModel: false,
      formModalLoading: true,
      formTitle: 0,
      formItem: {
        name: "",
        cellPhone: "",
        department: "",
        email: "",
        loginId: "",
        pwd: "",
        roleType: "",
        status: "",
        tel: "",
      },
      updateCode: "",
      ruleValidate: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        cellPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请选择所属部门", trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        loginId: [{ required: true, message: "请输入账号", trigger: "blur" }],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        roleType: [{ required: true, message: "请选择角色", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },
      selectData: [],
      formModel2: false,
      formModalLoading2: true,
      formItem2: {
        name: "",
        loginId: "",
        code: "",
        pwd: "",
      },
      ruleValidate2: {
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },

      authModalLoading: true,
      authModalVisible: false,
      permissionTreeData: [],
      currentCode: "",
      shopInfoValue: [],
      spInfoValue: [],
      sysPlatformValue: [],
      isAllSelect: false,
    };
  },
  computed: {
    ...mapGetters({
      roleList: "roles/getRolesAll",
      permission: "permission/getPermissionList",
      sysPlatformAll: "base/getBaseSysPlatformAll",
      spInfoQueryAll: "merchant/getSpInfoQueryAll",
      shopInfoQueryList: "shop/getShopInfoQueryList",
    }),
  },
  created() {
    this.getTree();
    this.getList();
    this.getUserTypeList();

    // 查询系统平台基础及控制信息
    this.$store.dispatch("base/getBaseSysPlatformAll");
    // 门店接口（门店管理）
    this.$store.dispatch("shop/getShopInfoQueryList", { pageSize: 1000 });
    // 查询资金商&服务商
    this.$store.dispatch("merchant/getSpInfoQueryAll");
  },
  watch: {
    // tree选择后收起选项
    "formItem.department"(a, b) {
      this.$refs.brick.click();
    },
    deep: true,
  },
  methods: {
    getUserTypeList() {
      this.$store.dispatch("roles/getRolesAll");
    },
    getTree() {
      this.$api["depAllSearch"]({}).then((res) => {
        if (res.code == "200") {
          let selectSt = {
            depName: "全部部门",
            code: "",
            opened: false,
            parentCode: "-1",
          };
          let list1 = [];
          if (res.data && res.data.length > 0) {
            list1 = [...res.data, selectSt];
          }
          this.selectData = this.tools.arrayToTree(list1, 1, "depName");
        }
      });
    },
    // 列表
    getList() {
      let data = {
        name: this.searchName,
        cellPhone: this.cellPhone,
        status: this.status,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.userQueryList(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          let list = res.data;
          if (!list || list.length == 0) {
            this.tbList = [];
            return;
          }
          this.tbList = list;
          this.total = res.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.searchName = "";
      this.cellPhone = "";
      this.status = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    checkChange(value) {
      if (value) {
        this.shopInfoValue = [];
        this.spInfoValue = [];
        this.sysPlatformValue = [];
      }
    },
    auth(d, index) {
      this.currentCode = d.code;
      this.$store
        .dispatch("permission/getPermissionList", {
          userCode: d.code || "",
        })
        .then((res) => {
          if (res.code == 200) {
            this.formatPermissonData(
              (res.data && res.data.permissionData) || []
            );
            // this.permissionModalFormList = this.permission;
            this.authModalVisible = true;
          }
        })
        .catch((err) => {});
    },
    formatPermissonData(array) {
      array.forEach((item) => {
        if (item.dataType == 99) {
          this.isAllSelect = true;
        }

        if (item.dataType == 1 && item.dataList) {
          this.shopInfoValue = Object.keys(item.dataList);
        }

        if (item.dataType == 2 && item.dataList) {
          this.spInfoValue = Object.keys(item.dataList);
        }

        if (item.dataType == 3 && item.dataList) {
          this.sysPlatformValue = Object.keys(item.dataList);
        }
      });
    },
    permissionTreeSubmmit() {
      this.authModalLoading = false;
      this.$nextTick(() => {
        this.authModalLoading = true;
      });

      const dataList = [];
      if (this.isAllSelect) {
        // dataType  =  99  "dataList": "ALL"
        dataList.push({
          dataType: 99, // 平台
          dataList: "ALL",
        });
      } else {
        dataList.push({
          dataType: 1, // 门店
          dataList: this.shopInfoValue.join(","),
        });
        dataList.push({
          dataType: 2, // 资金商
          dataList: this.spInfoValue.join(","),
        });
        dataList.push({
          dataType: 3, // 平台
          dataList: this.sysPlatformValue.join(","),
        });
      }
      console.log(this.shopInfoValue, this.sysPlatformValue, this.spInfoValue);

      // console.log(dataList)
      this.$store
        .dispatch("permission/updatePermissionList", {
          userCode: this.currentCode || "",
          dataList: dataList,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$Message.success("操作成功");
            this.permissionTreeCancel();
          } else {
            this.$Message.error(res.message || "操作失败");
          }
        })
        .catch((err) => {
          this.$Message.error("操作失败");
        });
    },
    permissionTreeCancel() {
      this.currentCode = "";
      this.shopInfoValue = [];
      this.spInfoValue = [];
      this.sysPlatformValue = [];
      (this.isAllSelect = false), (this.authModalVisible = false);
    },
    // 打开新增编辑
    openFn(d, i) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        Object.keys(this.formItem).forEach((key) => {
          this.formItem[key] = d[key];
        });
        this.updateCode = d.code;
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 新增编辑确定
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let data = this.formItem;
      let http = "userInsert";
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if (this.formTitle == 1) {
            data.code = this.updateCode;
            delete data["pwd"];
            http = "userUpdate";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.getList();
            }
          });
        }
      });
    },
    cancelAction() {
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 删除用户
    removeFn(d) {
      let data = {
        code: d.code,
        status: 5,
      };
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.userStatus(data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.getList();
            }
          });
        },
      });
    },
    passwordFn(d) {
      let that = this;
      Object.keys(this.formItem2).forEach((key) => {
        this.formItem2[key] = d[key];
      });
      this.$nextTick(() => {
        that.formModel2 = true;
      });
    },
    passwordSubmit() {
      this.formModalLoading2 = false;
      this.$nextTick(() => {
        this.formModalLoading2 = true;
      });
      let data = { ...this.formItem2 };
      delete data["name"];
      delete data["loginId"];
      this.$refs["formValidate2"].validate((valid) => {
        if (valid) {
          this.$api["userUpdatePwd"](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.passwordCancel();
              this.getList();
            }
          });
        }
      });
    },
    passwordCancel() {
      let that = this;
      Object.keys(this.formItem2).forEach((key) => {
        this.formItem2[key] = "";
      });
      this.$refs["formValidate2"].resetFields();
      this.$nextTick(() => {
        that.formModel2 = false;
      });
    },
    // 状态
    stateChange(v, d, i) {
      let s = d.status == 1 ? "2" : "1";
      let data = {
        code: d.code,
        status: s,
      };
      this.$api["userStatus"](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/basic/userManagement.vue